import axios from '@/libs/api.request'
import config from '@/config'

const privateCloudBaseUrl = config.basePrivateCloudUrl + '/cloud/api/v1/'

export const getPrivateCloudRouter = (params) => {
  return axios.request({
    url: privateCloudBaseUrl + 'router/',
    needPrivateCloudProjectHeader: true,
    params: params,
    method: 'get'
  })
}

export const getPrivateCloudAllRouter = () => {
  return axios.request({
    url: privateCloudBaseUrl + 'all_router_list/',
    method: 'get'
  })
}

export const detailPrivateCloudRouter = (id) => {
  return axios.request({
    url: privateCloudBaseUrl + 'router/' + id + '/',
    needPrivateCloudProjectHeader: true,
    method: 'get'
  })
}

export const changePrivateCloudRouter = (data, id) => {
  let url = privateCloudBaseUrl + 'router/'
  let method = 'post'
  if (id) {
    url += id + '/'
    method = 'put'
  }
  return axios.request({
    url: url,
    data: data,
    needPrivateCloudProjectHeader: true,
    method: method
  })
}

export const deletePrivateCloudRouter = (id) => {
  return axios.request({
    url: privateCloudBaseUrl + 'router/' + id + '/',
    needPrivateCloudProjectHeader: true,
    method: 'delete'
  })
}

export const privateCloudRouterInterfaceOperate = (data, id) => {
  return axios.request({
    url: privateCloudBaseUrl + 'router_interface_operate/' + id + '/',
    needPrivateCloudProjectHeader: true,
    data: data,
    method: 'post'
  })
}
